import React, { Fragment, useEffect, useState } from 'react'
import { TextField, Paper, Button, Box } from '@mui/material'

import useAsnBlogs from './useAsnBlog'
import { utcToLocal } from '../../utils/dateHelper'
import { SnackBar } from '../SnackBar/Snackbar'
import { SnackBarStatus } from '../../interfaces/SnackBar/SnackBarStatus'
import { useUser } from '../../hooks/useUser'
import { GenericTableV2 } from '../_EOS/GenericTable/GenericTableV2'
import { AsnBlog as AsnBlogInterface } from '../../interfaces/Asn/AsnBlog'
/*

Copyright 2022-05-11 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: Se módifica tamaño para bitácora de ASN
*/

interface AsnBlogProps {
  asnId: number
  asnNumber: string
  onClose?: () => void
}

export const AsnBlog: React.FC<AsnBlogProps> = ({ asnId, asnNumber, onClose }) => {
  const {
    userDataState: { userData }
  } = useUser()

  const [comment, setComment] = useState<string>('')

  const {
    loading,
    errorGetAsn,
    errorPostAsn,
    asnBlogs,
    getAsnBlogs,
    postAsnBlogs
  } = useAsnBlogs()

  const [snackBarStatus, setSnackBarStatus] = useState<SnackBarStatus>(
    new SnackBarStatus()
  )

  const handleSnackbar = (isOpen: boolean) => {
    setSnackBarStatus({ ...snackBarStatus, isOpen: isOpen })
  }

  const handlePostComment = () => {
    if (userData === undefined) {
      setSnackBarStatus({
        isOpen: true,
        message:
          'No fue posible obtener datos del usuario para agregar el comentario',
        status: 'error'
      })
    } else {
      const postComment = {
        asnId,
        asnNumber,
        comments: comment,
        createdUserId: userData.userId
      }
      postAsnBlogs(postComment)
      setComment('')
    }
  }

  useEffect(() => {
    getAsnBlogs(asnId, asnNumber)
  }, [getAsnBlogs])

  useEffect(() => {
    if (errorPostAsn !== undefined && errorPostAsn !== '') {
      setSnackBarStatus({
        isOpen: true,
        message: errorPostAsn || '',
        status: 'error'
      })
    }
  }, [errorPostAsn])

  const formatComments = (comments: string) => {
    const lines = comments.split('\n')
    const jsx = lines.map((line) => <div>{line}</div>)
    return jsx
  }

  const columnsConfig = [
    {
      key: 'createdDate' as keyof AsnBlogInterface,
      title: 'Fecha',
      align: 'center' as const,
      render: (value: any) => utcToLocal(value as string, 'dd/MM/yyyy HH:mm:ss')
    },
    {
      key: 'asnState' as keyof AsnBlogInterface,
      title: 'Estado',
      align: 'center' as const
    },
    {
      key: 'comments' as keyof AsnBlogInterface,
      title: 'Observaciones',
      align: 'left' as const,
      render: (value: any) => formatComments(value)
    },
    {
      key: 'createdUser' as keyof AsnBlogInterface,
      title: 'Usuario',
      align: 'center' as const,
      render: (value: any) => value.substring(0, value.indexOf('@'))
    }
  ]

  return (
    <Fragment>
      <Paper elevation={2} style={{ padding: '15px' }}>
        <GenericTableV2<AsnBlogInterface>
          data={asnBlogs}
          columns={columnsConfig}
          keyField='asnBlogId'
          loading={loading}
          emptyMessage={errorGetAsn || 'Sin registros'}
          styling={{
            dense: false,
            hoverEffect: true
          }}
        />
      </Paper>

      <Paper elevation={2} style={{ padding: '15px', marginTop: '20px' }}>
        <Box display='flex' gap={2} alignItems='flex-end'>
          <TextField
            disabled={loading}
            rows={1}
            maxRows={1}
            variant='outlined'
            multiline
            fullWidth
            placeholder='Ingresa una observación'
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
          <Button
            disabled={comment === '' || loading}
            variant='contained'
            color='primary'
            onClick={handlePostComment}
            style={{ height: '56px', padding: '0 32px', whiteSpace: 'nowrap' }}
          >
            Agregar
          </Button>
        </Box>
      </Paper>

      <Box display='flex' justifyContent='flex-end' mt={2}>
        <Button variant='outlined' onClick={onClose}>
          Cerrar
        </Button>
      </Box>

      <SnackBar
        open={snackBarStatus.isOpen}
        setOpen={handleSnackbar}
        message={snackBarStatus.message}
        status={snackBarStatus.status}
      ></SnackBar>
    </Fragment>
  )
}
